import { apiGet, apiPost, apiUpdate } from "../http";

export default {
  async getBrandsAPI() {
    return await apiGet("api/brands");
  },
  async getBrandAPI(id) {
    return await apiGet("api/brand/" + id);
  },
  async putBrandAPI(data) {
    return await apiUpdate(`api/brand/${data.id}`, data.body);
  },
  async postBrandAPI(data) {
    return await apiPost(`api/brand`, data);
  },
};
